import utils from '@src/common/utils'
import { Dic } from '$utils'
export const alarmOption = function (that) {
  return{
    emptyText: '暂无数据',
    page: true,
    stripe: true,
    maxHeight: '100%',
    column: [
      {
        label: '设备id',
        prop: 'thirdDeviceId',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: '告警时间',
        prop: 'alarmTime',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: ' SOE缓存位置',
        prop: 'soePosition',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: '串口号',
        prop: 'serialPort',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: ' 标准库序号',
        prop: 'standardLibrary',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
      {
        label: '剩余电流',
        prop: 'currentElectrical',
        align: 'center',
        viewDisplay: true,
        overHidden: true,
      },
    ]
  }
}
export default alarmOption